import { StyledIconUserStar } from './IconUserStar.styled';

const IconUserStar = () => {
  return <StyledIconUserStar />;
};

export default IconUserStar;
